window.app.controller('partnerOfficeCtrl', ['$scope', '$http', function ($scope, $http, fileReader) {

    $scope.fileSize = '';
    $scope.fileType = '';

    $scope.sendPartnerInfo = function () {
        $scope.sendXHR({
            url: '/rest/affiliateProgram/officeProcess/profile/execute',
            data: $scope.partnerInfo,
            successFunc: $scope.profileRequestSuccess,
            errorFunc: $scope.requestFail,
        });
    };

    $scope.profileRequestSuccess = (resp) => {
        console.log($scope.myFile)
        if (resp.data.partnerProfile) {
            $http({
                method: 'POST',
                url: '/rest/affiliateProgram/officeProcess/profile/upload',
                headers: { 'Content-Type': undefined },
                transformRequest: function (data) {
                    var formData = new FormData();
                    formData.append("file", data.files);
                    return formData;
                },
                data: { files: $scope.myFile }
            });
            location.reload();
        } else {
            $scope.showAlert('error', resp.data.errorMessage)
        }
    };

    $scope.hoursList = () => {
        let hours = [];
        for (let i = 0; hours.length < 25; i++) {
            hours.push(i + '')
        }
        return hours;
    };

    $scope.logoutPartner = () => {
        sessionStorage.sessionInProcces = '';
        $scope.sendXHR({
            url: '/api/front/authorization/logout/logout',
            method: 'post',
            data: '',
            successFunc: $scope.reloadPage
        })
    }

    $scope.reloadPage = function () {
        location.reload();
    }

}]);



// WEBPACK FOOTER //
// src/js/controllers/partner/officeCtrl.js